// import Home from '@/pages/Home/Index.vue'
import VueRouter from 'vue-router'
const routes = [
  {
    path: '/',
    name: 'home',
    meta: {
      title: '创新智造，永续未来'
    },
    component: () => import(/* webpackChunkName: "home" */ '@/pages/Home/Index.vue')
  },
  {
    path: '/loading',
    name: 'loading',
    meta: {
      title: '创新智造，永续未来'
    },
    component: () => import(/* webpackChunkName: "loading" */ '@/pages/Loading/Index.vue')
  },
  {
    path: '/store',
    name: 'store',
    meta: {
      title: '创新智造，永续未来'
    },
    component: () => import(/* webpackChunkName: "store" */ '@/pages/Store/Index.vue')
  },
  {
    path: '/consult',
    name: 'consult',
    meta: {
      title: '创新智造，永续未来'
    },
    component: () => import(/* webpackChunkName: "consult" */ '@/pages/Consult/Index.vue')
  }
]
const router = new VueRouter({
  routes // (缩写) 相当于 routes: routes
})
export default router
